import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import CSS from "./index.module.scss";
import MobileContext from "../../context.js";
import { animated, useInView } from "@react-spring/web";

const Partner = () => {
  const { t } = useTranslation();
  const mobile = useContext(MobileContext);
  const [ref, refStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  return (
    <div className={CSS.partner}>
      <div className={CSS.title}>{t("$singlee_ab_md5")}</div>
      <div
        className={CSS.subtitle}
        style={{ color: "#333", marginBottom: mobile ? "20px" : "42px" }}
      >
        {t("$singlee_pt1")}
      </div>
      <animated.div
        ref={ref}
        className={`${mobile ? CSS.imgV : CSS.imgH} `}
        style={refStyle}
      ></animated.div>
    </div>
  );
};

export default React.memo(Partner);
